export const dateFormats = {
  DEFAULT: "DD.MM.YYYY",
};
